<template>
  <div class="custom-date-picker">
    <slot name="label">
      <label v-if="label" :for="id" class="va-input__container__label" :class="{'text-danger': error}">
        {{label}}
      </label>
    </slot>
    <div class="date-picker-wrapper">
      <va-date-picker
        :id="id"
        :value="dateInterval"
        :config="rangeDatePickerConfig"
        :placeholder="placeholder"
        :disabled="disabled"
      >
        <span slot="append-icon">
          <span class="d-flex align-items-center">
            <span class="clickable clear-datepicker-icon"
              v-if="value.start && value.end && clearable && !disabled"
              @click.stop="$emit('input', { start: null, end: null })"
            >
            <va-icon name="fa fa-times"></va-icon>
            </span>
            <span>
              <va-icon :class="iconClass"></va-icon>
            </span>
          </span>
        </span>
      </va-date-picker>
    </div>
    <div class="text-danger text-break" v-if="error">
      <small v-for="(error, index) in errorMessages" :key="index">
        {{error}}
      </small>
    </div>
  </div>
</template>

<script>
import CurrentLocaleMixin from '@/mixins/CurrentLocaleMixin'
import { Portuguese as PTLocale } from 'flatpickr/dist/l10n/pt'
import { Spanish as ESLocale } from 'flatpickr/dist/l10n/es'
import { get as _get } from 'lodash'

PTLocale.firstDayOfWeek = 1
PTLocale.rangeSeparator = ' a '

export default {
  props: {
    id: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    value: {
      type: Object,
      required: false,
      validator: function (value) {
        return value.hasOwnProperty('start') && value.hasOwnProperty('end')
      }
    },
    config: {
      type: Object,
      required: false,
      defaul: () => { return {} }
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    errorMessages: {
      type: Array,
      required: false
    },
    iconClass: {
      type: String,
      required: false,
      default: 'fa fa-calendar'
    }
  },
  mixins: [
    CurrentLocaleMixin
  ],
  computed: {
    dateInterval: function () {
      if (this.value.start && this.value.end) {
        switch (this.locale) {
          case 'pt':
            return this.value.start + ' a ' + this.value.end
          case 'es':
            return this.value.start + ' a ' + this.value.end
          default:
            return this.value.start + ' to ' + this.value.end
        }
      }
      return ''
    },
    rangeDatePickerConfig: function () {
      let config = { mode: 'range' }

      if (this.locale === 'pt') {
        config.locale = PTLocale
      } else if (this.locale === 'es') {
        config.locale = ESLocale
      } else {
        config.locale = { firstDayOfWeek: 1 }
      }

      let maxInterval = _get(this.config, 'maxInterval', null)

      config.onChange = (selectedDates, dateStr, instance) => {
        if (selectedDates.length === 0) {
          this.$emit('input', { start: null, end: null })
        } else if (selectedDates.length === 1) {
          if (maxInterval !== null) {
            instance.set('minDate', this.moment(selectedDates[0]).subtract(maxInterval.value, maxInterval.unit).format('YYYY-MM-DD'))
            instance.set('maxDate', this.moment(selectedDates[0]).add(maxInterval.value, maxInterval.unit).format('YYYY-MM-DD'))
          }
        } else if (selectedDates.length === 2) {
          let start = this.moment(selectedDates[0]).format('YYYY-MM-DD')
          let end = this.moment(selectedDates[1]).format('YYYY-MM-DD')
          this.$emit('input', { start, end })
        }
      }

      if (maxInterval !== null) {
        config.onClose = (selectedDates, dateStr, instance) => {
          instance.set('minDate', null)
          instance.set('maxDate', null)
        }
      }

      Object.assign(config, this.config)

      return config
    }
  }
}
</script>
